import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/auth.js'), 'auth.js')
  resolveStoreModules(require('../store/blog.js'), 'blog.js')
  resolveStoreModules(require('../store/business-steps.js'), 'business-steps.js')
  resolveStoreModules(require('../store/business-v2.js'), 'business-v2.js')
  resolveStoreModules(require('../store/business.js'), 'business.js')
  resolveStoreModules(require('../store/chat.js'), 'chat.js')
  resolveStoreModules(require('../store/company.js'), 'company.js')
  resolveStoreModules(require('../store/directories.js'), 'directories.js')
  resolveStoreModules(require('../store/documents.js'), 'documents.js')
  resolveStoreModules(require('../store/footer.js'), 'footer.js')
  resolveStoreModules(require('../store/franchisee-steps.js'), 'franchisee-steps.js')
  resolveStoreModules(require('../store/franchisor-steps.js'), 'franchisor-steps.js')
  resolveStoreModules(require('../store/helper.js'), 'helper.js')
  resolveStoreModules(require('../store/hubspot.js'), 'hubspot.js')
  resolveStoreModules(require('../store/iframe.js'), 'iframe.js')
  resolveStoreModules(require('../store/landing.js'), 'landing.js')
  resolveStoreModules(require('../store/lang.js'), 'lang.js')
  resolveStoreModules(require('../store/login.js'), 'login.js')
  resolveStoreModules(require('../store/manage-lead.js'), 'manage-lead.js')
  resolveStoreModules(require('../store/modal-message.js'), 'modal-message.js')
  resolveStoreModules(require('../store/mutation-types.js'), 'mutation-types.js')
  resolveStoreModules(require('../store/nav.js'), 'nav.js')
  resolveStoreModules(require('../store/notifications.js'), 'notifications.js')
  resolveStoreModules(require('../store/pages.js'), 'pages.js')
  resolveStoreModules(require('../store/payment.js'), 'payment.js')
  resolveStoreModules(require('../store/rating.js'), 'rating.js')
  resolveStoreModules(require('../store/registration.js'), 'registration.js')
  resolveStoreModules(require('../store/search.js'), 'search.js')
  resolveStoreModules(require('../store/seo.js'), 'seo.js')
  resolveStoreModules(require('../store/top-franchise.js'), 'top-franchise.js')
  resolveStoreModules(require('../store/constants/index.js'), 'constants/index.js')
  resolveStoreModules(require('../store/account/index.js'), 'account/index.js')
  resolveStoreModules(require('../store/account-franchisor/index.js'), 'account-franchisor/index.js')
  resolveStoreModules(require('../store/account-franchisor/all-tasks.js'), 'account-franchisor/all-tasks.js')
  resolveStoreModules(require('../store/account-franchisor/contacts.js'), 'account-franchisor/contacts.js')
  resolveStoreModules(require('../store/account-franchisor/forms.js'), 'account-franchisor/forms.js')
  resolveStoreModules(require('../store/account/answers.js'), 'account/answers.js')
  resolveStoreModules(require('../store/account/business.js'), 'account/business.js')
  resolveStoreModules(require('../store/account/question.js'), 'account/question.js')
  resolveStoreModules(require('../store/account/workbook.js'), 'account/workbook.js')
  resolveStoreModules(require('../store/modals/contact.js'), 'modals/contact.js')
  resolveStoreModules(require('../store/account-franchisor/actions/history.js'), 'account-franchisor/actions/history.js')
  resolveStoreModules(require('../store/account-franchisor/actions/notes.js'), 'account-franchisor/actions/notes.js')
  resolveStoreModules(require('../store/account-franchisor/actions/tasks.js'), 'account-franchisor/actions/tasks.js')
  resolveStoreModules(require('../store/mobile/franchisee/directory.js'), 'mobile/franchisee/directory.js')
  resolveStoreModules(require('../store/mobile/franchisee/matches.js'), 'mobile/franchisee/matches.js')
  resolveStoreModules(require('../store/mobile/franchisee/signUp.js'), 'mobile/franchisee/signUp.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
